export default __webpack_public_path__ + "locales/ja-JP/MainBar.json?hash=e1ce2040b1f2d2a488bfb8013a0ac8ad";